<template>
  <FlexTable class="programs-table">
    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" />
    <transition-group name="programs-transition">
      <div
        class="flex-trow"
        v-for="(program, index) in dataPrograms.slice(startIndex, endIndex)"
        :key="'program-'+program.id"
      >
        <div class="remove-program" @click="showModal(startIndex + index)">x</div>
        <div class="right-menu">
          <div class="right-menu-btn" @click="goToProgram(program.id)">Ir</div>
        </div>
        <div class="flex-td name-cell">{{program.name}}</div>
      </div>
    </transition-group>
  </FlexTable>
</template>

<script>
import FlexTable from "./base/FlexTable";
import patientService from "../../services/patientService";

export default {
  name: "ProgramsTable",
  components: { FlexTable },
  model: {
    prop: "programs",
    event: "change"
  },
  props: {
    programs: {
      type: Array,
      default: function() {
        return [];
      }
    },
    perPage: {
      type: Number,
      default: 10
    }
  },
  methods: {
    showModal(index) {
      // we must pass object params with all the information
      let program = this.dataPrograms[index];
      const params = {
        title: "Eliminar programa",
        text:
          'Estas seguro que quieres eliminar el programa "' +
          program.name +
          '"?',
        // we are passing callback method for our confirm button
        onConfirm: () => {
          return this.deleteProgram(index);
        }
      };
      // now we can call function that will reveal our modal
      this.$deleteModal.show(params);
    },
    deleteProgram: function(index) {
      patientService.delete_program({ id: this.dataPrograms[index].id }).then(
        data => {
          this.dataPrograms.splice(index, 1);
          this.$toasted.success(data.message);
        },
        error => {
          this.$toasted.error("Ha ocurrido un error!");
          console.error(error);
        }
      );
    },
    goToProgram: function(id) {
      this.$router.push({ name: "program", params: { id: id } });
    }
  },
  watch: {
    dataPrograms: function(val) {
      this.$emit("change", val);
    },
    programs: function(val) {
      this.dataPrograms = val;
    }
  },
  data: function() {
    return {
      dataPrograms: this.programs,
      currentPage: 1
    };
  },
  computed: {
    rows() {
      return this.dataPrograms.length;
    },
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      return this.currentPage * this.perPage;
    }
  }
};
</script>

<style scoped lang="scss">
.programs-table {
  overflow-x: auto;
  overflow-y: hidden;
  padding: 4px;
  width: 100%;

  & span {
    width: 100%;
  }
}

.name-cell {
  padding-left: 3rem;
}

.flex-trow {
  position: relative;
  border-left: 1px solid $gray-500;
  border-right: 1px solid $gray-500;
  border-bottom: 1px solid $gray-300;

  & .right-menu {
    position: absolute;
    height: 100%;
    right: 0;
    display: flex;

    & .right-menu-btn {
      border-left: 1px solid $gray-500;
      padding: 0.75rem;
      min-width: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background-color: rgb(23, 162, 184);
      color: white;
      height: 100%;
    }

    & .right-menu-btn:hover {
      background-color: rgb(21, 146, 165);
    }
  }

  &:first-child {
    border-top: 1px solid $gray-500;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;

    & .right-menu .right-menu-btn:last-child {
      border-top-right-radius: 10px;
    }
  }

  &:last-child {
    border-bottom: 1px solid $gray-500;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;

    & .right-menu .right-menu-btn:last-child {
      border-bottom-right-radius: 10px;
    }
  }

  & .remove-program {
    display: none;
    position: absolute;
    margin: -0.5px;
    height: 100%;
    align-items: center;
    width: 32px;
    justify-content: center;
    color: black;
    background-color: rgba(grey, 0.1);
  }

  &:hover .remove-program {
    display: flex;
    cursor: pointer;
  }

  &:first-child .remove-program {
    border-top-left-radius: 10px;
  }

  &:last-child .remove-program {
    border-bottom-left-radius: 10px;
  }
}

.flex-td {
  justify-content: flex-start;
  text-align: left;
  border: none;
}

.programs-transition-enter-active,
.programs-transition-leave-active {
  transition: opacity 0.2s;
}

.programs-transition-enter,
.programs-transition-leave-to {
  opacity: 0;
}

.programs-transition-leave,
.programs-transition-enter-to {
  opacity: 1;
}
</style>